"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDateRange = exports.getDaysInFuture = exports.mergeMeetings = exports.getUserColor = exports.validateEndTime = exports.validateEndDate = exports.rangeToDate = exports.validatePhoneNumber = exports.createLink = exports.createDisabledRange = exports.getPhoneField = exports.getLocationField = exports.getDefaultFields = exports.getAvailabilityData = exports.transformMemberOrTeam = exports.convertMembersToBuckets = exports.convertSchedulerBucketLocalToGuestBucket = exports.convertGuestBucketToSchedulerBucketLocal = exports.convertFromBufferValueToString = exports.convertFromBufferValueToNumber = exports.convertToBufferValue = exports.filterDuplicateMeetings = exports.makeActionCreator = void 0;
const constants_1 = require("@/app/shared/constants");
const colors_1 = require("@/app/shared/constants/colors");
const helpers_1 = require("@/app/shared/helpers");
const moment_1 = __importDefault(require("moment"));
const uuid_1 = require("uuid");
const constants_2 = require("./constants");
function makeActionCreator(type) {
    return (payload) => ({ type, payload });
}
exports.makeActionCreator = makeActionCreator;
const filterDuplicateMeetings = (result) => {
    if (!result) {
        return null;
    }
    const seen = new Set();
    return {
        ...result,
        meetings: result.meetings.filter(({ title, startsAt, finishesAt }) => {
            const key = `${title}-${startsAt}-${finishesAt}`;
            if (seen.has(key))
                return false;
            seen.add(key);
            return true;
        }),
    };
};
exports.filterDuplicateMeetings = filterDuplicateMeetings;
const convertToBufferValue = (buffer) => buffer ? ("MINUTE" /* DurationTimeUnit.MINUTE */ + buffer.replace('m', '')) : "NONE" /* SchedulerBufferTime.NONE */;
exports.convertToBufferValue = convertToBufferValue;
const convertFromBufferValueToNumber = (bufferValue) => {
    return bufferValue === "NONE" /* SchedulerBufferTime.NONE */ ? 0 : Number(bufferValue.replace("MINUTE" /* DurationTimeUnit.MINUTE */, ''));
};
exports.convertFromBufferValueToNumber = convertFromBufferValueToNumber;
const convertFromBufferValueToString = (bufferValue) => {
    const number = (0, exports.convertFromBufferValueToNumber)(bufferValue);
    return number ? number + 'm' : null;
};
exports.convertFromBufferValueToString = convertFromBufferValueToString;
const convertGuestBucketToSchedulerBucketLocal = (bucket, bucketName) => {
    return {
        id: bucketName,
        name: bucketName,
        type: "SUMO1" /* MemberType.SUMO1 */,
        subType: "BUCKET" /* MemberSubType.BUCKET */,
        email: undefined,
        integration: undefined,
        workspaceIds: null,
        members: bucket.members,
    };
};
exports.convertGuestBucketToSchedulerBucketLocal = convertGuestBucketToSchedulerBucketLocal;
const convertSchedulerBucketLocalToGuestBucket = (bucket, isHost = false) => ({
    members: bucket.members,
    bucketType: constants_2.ROUND_ROBIN_BUCKET_TYPE,
    isHost,
});
exports.convertSchedulerBucketLocalToGuestBucket = convertSchedulerBucketLocalToGuestBucket;
const convertMembersToBuckets = (host, guests) => {
    const buckets = [];
    // Add host bucket first
    if (host) {
        if ('members' in host) {
            // Host is already a bucket - convert SchedulerBucketLocal back to GuestBucket
            const hostBucket = (0, exports.convertSchedulerBucketLocalToGuestBucket)(host, true);
            buckets.push(hostBucket);
        }
        else {
            // Host is a user or team - create standard bucket with single member
            buckets.push({
                members: [(0, exports.transformMemberOrTeam)(host)].filter(Boolean),
                bucketType: constants_2.STANDARD_BUCKET_TYPE,
                isHost: true,
            });
        }
    }
    // Add guest buckets
    guests.forEach((guest) => {
        if ('members' in guest) {
            // Guest is already a bucket - convert SchedulerBucketLocal back to GuestBucket
            const guestBucket = (0, exports.convertSchedulerBucketLocalToGuestBucket)(guest);
            buckets.push(guestBucket);
        }
        else {
            // Guest is a user or team - create standard bucket with single member
            buckets.push({
                members: [(0, exports.transformMemberOrTeam)(guest)].filter(Boolean),
                bucketType: constants_2.STANDARD_BUCKET_TYPE,
                isHost: false,
            });
        }
    });
    return buckets;
};
exports.convertMembersToBuckets = convertMembersToBuckets;
const transformMemberOrTeam = (member) => {
    if (!member)
        return null;
    return {
        id: member.id,
        email: member.email,
        name: member.name,
        type: member.type,
        subType: member.subType,
    };
};
exports.transformMemberOrTeam = transformMemberOrTeam;
const getAvailabilityData = (availability, availabilityCustom, availabilityRange, availabilityRollingWindow, availabilityRollingExpiration) => {
    switch (availability) {
        case "OPEN" /* SchedulerAvailability.OPEN */: {
            return {};
        }
        case "CUSTOM" /* SchedulerAvailability.CUSTOM */: {
            return {
                customRanges: availabilityCustom.map((availability) => ({
                    from: new Date(availability.start).getTime(),
                    to: new Date(availability.end).getTime(),
                })),
            };
        }
        case "RANGE" /* SchedulerAvailability.RANGE */: {
            const from = new Date();
            const to = new Date();
            // Set from and to dates
            if (availabilityRange.startDate) {
                from.setDate(availabilityRange.startDate[0]);
                from.setMonth(availabilityRange.startDate[1]);
                from.setFullYear(availabilityRange.startDate[2]);
            }
            if (availabilityRange.endDate) {
                to.setDate(availabilityRange.endDate[0]);
                to.setMonth(availabilityRange.endDate[1]);
                to.setFullYear(availabilityRange.endDate[2]);
            }
            // Set from and to times
            if (availabilityRange.startTime) {
                from.setHours(availabilityRange.startTime[0], availabilityRange.startTime[1], 0, 0);
            }
            if (availabilityRange.endTime) {
                to.setHours(availabilityRange.endTime[0], availabilityRange.endTime[1], 0, 0);
            }
            // Generate daily custom ranges within date range
            const customRanges = [];
            for (let current = new Date(from); current < to; current.setDate(current.getDate() + 1)) {
                const dailyFrom = new Date(current);
                const dailyTo = new Date(current);
                if (availabilityRange.startTime) {
                    dailyFrom.setHours(availabilityRange.startTime[0], availabilityRange.startTime[1], 0, 0);
                }
                if (availabilityRange.endTime) {
                    dailyTo.setHours(availabilityRange.endTime[0], availabilityRange.endTime[1], 0, 0);
                }
                customRanges.push({
                    from: dailyFrom.getTime(),
                    to: dailyTo.getTime(),
                });
            }
            return { customRanges };
        }
        case "ROLLING" /* SchedulerAvailability.ROLLING */: {
            let expiresAt = null;
            if (availabilityRollingExpiration) {
                const date = new Date();
                date.setDate(availabilityRollingExpiration[0]);
                date.setMonth(availabilityRollingExpiration[1]);
                date.setFullYear(availabilityRollingExpiration[2]);
                expiresAt = date.getTime().toString();
            }
            return {
                rollingWindowDays: availabilityRollingWindow,
                expiresAt,
            };
        }
        default: {
            return {};
        }
    }
};
exports.getAvailabilityData = getAvailabilityData;
const getDefaultFields = (name, email, hasCustomRequiredFields) => [
    {
        id: (0, uuid_1.v4)(),
        answers: [],
        enabled: true,
        label: 'Full Name',
        required: true,
        type: constants_1.CustomType.TEXT,
        fieldType: constants_1.CustomFieldType.NAME,
        value: hasCustomRequiredFields ? name : name || email, // fill empty name with email only if no other input required
    },
    {
        id: (0, uuid_1.v4)(),
        answers: [],
        enabled: true,
        label: 'Email',
        required: true,
        type: constants_1.CustomType.TEXT,
        fieldType: constants_1.CustomFieldType.EMAIL,
        value: email,
    },
];
exports.getDefaultFields = getDefaultFields;
const getLocationField = () => ({
    id: (0, uuid_1.v4)(),
    answers: [],
    enabled: true,
    label: 'Location',
    required: true,
    type: constants_1.CustomType.TEXT,
    fieldType: constants_1.CustomFieldType.LOCATION,
});
exports.getLocationField = getLocationField;
const getPhoneField = () => ({
    id: (0, uuid_1.v4)(),
    answers: [],
    enabled: true,
    label: 'Phone',
    required: true,
    type: constants_1.CustomType.PHONE,
    fieldType: constants_1.CustomFieldType.PHONE,
});
exports.getPhoneField = getPhoneField;
const createDisabledRange = (event = {}, timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone) => {
    const defaultEvent = {
        display: 'background',
        borderColor: 'var(--bluegray-200)',
        backgroundColor: 'var(--bluegray-200)',
    };
    return {
        ...defaultEvent,
        ...event,
        type: 'DISABLED_RANGE',
        start: (0, moment_1.default)(event.start).tz(timeZone).format('YYYY-MM-DDTHH:mm:ssZ'),
        end: (0, moment_1.default)(event.end).tz(timeZone).format('YYYY-MM-DDTHH:mm:ssZ'),
    };
};
exports.createDisabledRange = createDisabledRange;
const createLink = ({ bookingPageId, spot }) => {
    return helpers_1.query.set(`${SUMO1_APPLICATION_ORIGIN}/book/${bookingPageId}`, { source: 'inbox', spot });
};
exports.createLink = createLink;
const validatePhoneNumber = (phoneNumber) => {
    const phoneLength = phoneNumber?.replace(/-/g, '').length || 0;
    return phoneLength >= 4 && phoneLength <= 16;
};
exports.validatePhoneNumber = validatePhoneNumber;
const rangeToDate = (range) => {
    if (!range) {
        return undefined;
    }
    const date = new Date();
    date.setDate(range[0]);
    date.setMonth(range[1]);
    date.setFullYear(range[2]);
    return date;
};
exports.rangeToDate = rangeToDate;
const validateEndDate = (startDate, endDate) => {
    const start = (0, exports.rangeToDate)(startDate);
    const end = (0, exports.rangeToDate)(endDate);
    return Boolean(start && end && end.getTime() >= start.getTime());
};
exports.validateEndDate = validateEndDate;
const validateEndTime = (startTime, endTime) => {
    if (!startTime || !endTime) {
        return false;
    }
    return startTime[0] * 60 + startTime[1] < endTime[0] * 60 + endTime[1];
};
exports.validateEndTime = validateEndTime;
const getUserColor = (userId, userColors) => {
    if (!userId || !userColors)
        return { id: userId, ...colors_1.FALLBACK_COLOR };
    switch (userId) {
        case userColors.host.id:
            return userColors.host;
        case userColors.mainGuest.id:
            return userColors.mainGuest;
        case userColors.guests.find((guest) => guest.id === userId)?.id:
            return userColors.guests.find((guest) => guest.id === userId);
        default:
            return { id: userId, ...colors_1.FALLBACK_COLOR };
    }
};
exports.getUserColor = getUserColor;
const mergeMeetings = (meetings) => {
    const sortedMeetings = [...meetings].sort((a, b) => new Date(a.startsAt).getTime() - new Date(b.startsAt).getTime());
    const mergedMeetings = [];
    for (const meeting of sortedMeetings) {
        const lastMerged = mergedMeetings.at(-1);
        const lastMergedTime = new Date(lastMerged?.finishesAt ?? 0).getTime();
        const meetingStartTime = new Date(meeting.startsAt).getTime();
        const meetingEndTime = new Date(meeting.finishesAt).getTime();
        if (lastMerged && lastMergedTime >= meetingStartTime) {
            lastMerged.finishesAt = lastMergedTime > meetingEndTime ? lastMerged.finishesAt : meeting.finishesAt;
        }
        else {
            mergedMeetings.push({ ...meeting });
        }
    }
    return mergedMeetings;
};
exports.mergeMeetings = mergeMeetings;
const getDaysInFuture = (calendarFinishAt) => {
    const diffMillis = calendarFinishAt - Date.now();
    return Math.ceil(diffMillis / (1000 * 60 * 60 * 24));
};
exports.getDaysInFuture = getDaysInFuture;
const getDateRange = ({ availability, availabilityRollingWindow, calendarFinishAt, }) => {
    switch (availability) {
        case "OPEN" /* SchedulerAvailability.OPEN */:
            return {
                type: "DAYS_IN_FUTURE" /* SUMO1_server.DateRangeType.DAYS_IN_FUTURE */,
                count: Math.max(30, (0, exports.getDaysInFuture)(calendarFinishAt)),
            };
        case "ROLLING" /* SchedulerAvailability.ROLLING */:
            return {
                type: "DAYS_IN_FUTURE" /* SUMO1_server.DateRangeType.DAYS_IN_FUTURE */,
                count: availabilityRollingWindow,
            };
        default:
            return {
                type: "UNLIMITED" /* SUMO1_server.DateRangeType.UNLIMITED */,
            };
    }
};
exports.getDateRange = getDateRange;
